import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ProviderUserProfile } from './contexts/UserProfileContext';
import { ProviderGlobalFeatures } from './contexts/GlobalFeatures';
import { NotificationsProvider } from './contexts/NotificationsContext';
import ThemeWrapper from './contexts/ThemeWrapper';
import AppGate from './AppGate';
import { setFavicon } from './utils/usefulFunctions';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './contexts/AuthContext';
import { HotelOwnerProvider } from './contexts/HotelOwnerContext';
import NotificationsBar from './components/NotificationsBar';
import './stylesheets/theme.module.scss';
import './stylesheets/App.scss';
import './stylesheets/common.scss';
import { AppConfigurationProvider } from './contexts/AppConfigurationContext';
import { ServerNotificationsProvider } from './contexts/ServerNotificationsContext';
import { ProcessesProvider } from './contexts/ProcessesContext';

setFavicon();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <BrowserRouter>
        <ErrorBoundary>
            <ProviderGlobalFeatures>
                <NotificationsProvider>
                    <AuthProvider>
                        <AppConfigurationProvider>
                            <ProviderUserProfile>
                                <HotelOwnerProvider>
                                    <ServerNotificationsProvider>
                                        <ProcessesProvider>
                                            <ThemeWrapper>
                                                <Switch>
                                                    <Route
                                                        path='/'
                                                        render={props => (
                                                            <AppGate
                                                                {...props}
                                                            />
                                                        )}
                                                    />
                                                </Switch>
                                                <NotificationsBar />
                                            </ThemeWrapper>
                                        </ProcessesProvider>
                                    </ServerNotificationsProvider>
                                </HotelOwnerProvider>
                            </ProviderUserProfile>
                        </AppConfigurationProvider>
                    </AuthProvider>
                </NotificationsProvider>
            </ProviderGlobalFeatures>
        </ErrorBoundary>
    </BrowserRouter>
);
